<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name" />

    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width=" ">
        <el-form-item label="产品ID">
          <el-input v-model="searchData.id" size="small" placeholder="请输入产品ID" />
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="searchData.productName" size="small" placeholder="请输入产品名称" />
        </el-form-item>
        <el-form-item label="产品类型">
          <SelectDict v-model="searchData.productType" dict-code="ProductType" width="180" size="small" />
        </el-form-item>
        <el-form-item label="对接商务">
          <SelectAdmin v-model="searchData.businessUserId"></SelectAdmin>
        </el-form-item>
        <el-form-item label="合作方式">
          <el-select v-model="searchData.cooperationMethod" size="small" placeholder="请选择">
            <el-option v-for="item in COOPERATION_METHOD_DICT" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" icon="el-icon-search" @click="getProductList">搜索</el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="header-tabs">
      <el-radio-group v-model="searchData.status" size="small" @input="getProductList">
        <el-radio-button :label="null">全部</el-radio-button>
        <el-radio-button :label="1">已上架</el-radio-button>
        <el-radio-button :label="0">已下架</el-radio-button>
      </el-radio-group>
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.product_list_add)"
        style="margin-left:20px"
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="$router.push({ name: 'ProductAdd' })"
      >新增</el-button>
    </div>
    <el-divider></el-divider>

    <tp-table
        ref="productTable"
        :tableData="list"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
        @handleSortChange="handleSortChange"/>

    <!-- 权重配置 -->
    <el-dialog title="权重配置" :visible.sync="dialogWeight" class="weight-dialog" width="800px">
      <el-form ref="formWeight" :model="productInfo" label-width="130px">
        <el-form-item label="当前权重：">{{ productInfo.productWeight }}</el-form-item>
        <el-form-item label="权重设置：">
          <el-input-number v-model="productInfo.newProductWeight" size="small" placeholder="请输入" :min="1" :max="999" style="width:200px;"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top:20px;">
        <el-button @click="dialogWeight = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitWeight" size="mini">提 交</el-button>
      </div>
    </el-dialog>

    <div style="height:60px;"></div>
  </div>
</template>

<script>
import {
  getProductListAPI,
  deleteProductAPI,
  editWeightAPI,
  editStatusAPI,
} from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import SelectAdmin from '@/views/components/select-admin.vue';
import SelectDict from "@/views/components/select-dict.vue";
import { COOPERATION_METHOD_DICT } from "@/enum/dict";

const columns = [
  {
    label: 'ID',
    prop: 'id',
    minWidth: '80',
    customRender(h, row) {
      return <p>{row['id']}</p>
    }
  },
  {
    label: '产品名称',
    prop: 'productName',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row['productName']}</p>
    }
  },
  {
    label: '产品类型',
    prop: 'productTypeName',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['productTypeName']}</p>
    }
  },
  {
    label: '产品权重',
    prop: 'productWeight',
    minWidth: '120',
    sortable: true,
    customRender(h, row) {
      return <p>{row['productWeight']}</p>
    }
  },
  {
    label: '对接商务',
    prop: 'businessUserName',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['businessUser']?.['userName']}</p>
    }
  },
  {
    label: '产品供应商',
    prop: 'companyName',
    minWidth: '200',
    customRender(h, row) {
      return <p>{row['companyName']}</p>
    }
  },
  {
    label: '合作方式',
    prop: 'cooperationMethodName',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['cooperationMethodName']}</p>
    }
  },
  {
    label: '结算方式',
    prop: 'settleMethodDesc',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['settleMethodDesc']}</p>
    }
  },
  {
    label: '结算备注',
    prop: 'settleRemark',
    minWidth: '180',
    customRender(h, row) {
      return <p>{row['settleRemark']}</p>
    }
  },
  {
    label: '创建时间',
    prop: 'createTime',
    minWidth: '180',
    customRender(h, row) {
      return <p>{row['createTime']}</p>
    }
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '100',
    customRender(h, row) {
      return (
          <div>
            <el-switch
                disabled={!this.isShowBtn(this.AUTH_BTN.product_list_status)}
                class="switch"
                onChange={() => this.editStatus(row)}
                v-model={row['status']}
                active-value={true}
                inactive-value={false}
                active-text="上架"
                inactive-text="下架"
            ></el-switch>
          </div>
      )
    }
  },
  {
    label: '操作',
    width: '150',
    fixed: 'right',
    customRender(h, row) {
      return (
        <div>
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.product_list_edit)}
            style="margin-right:10px;"
            underline={false}
            type="primary"
            onClick={() => this.$router.push({ name: 'ProductEdit', params: { id: row['id'] } })}
          >
            编辑
          </el-link>

          <el-link
              disabled={!this.isShowBtn(this.AUTH_BTN.product_list_weight)}
              style="margin-right:10px;"
              underline={false}
              type="primary"
              onClick={() => this.handleWeight(row)}
          >
            权重
          </el-link>

          <el-link
            disabled={row['status'] == 1 || !this.isShowBtn(this.AUTH_BTN.product_list_del)}
            underline={false}
            type="primary"
            onClick={() => this.handleDel(row['id'])}
          >
            删除
          </el-link>
        </div>
      )
    }
  }
]

export default {
  name: 'ProductList',
  mixins: [authBtnMixin],
  components: { SelectAdmin, SelectDict },
  data() {
    return {
      COOPERATION_METHOD_DICT,
      dialogVisible: false,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        id: undefined,
        productName: '',
        productType: undefined,
        status: undefined,
        businessUserId: undefined,
        cooperationMethod: undefined,
        sortField: '',
      },
      dialogWeight: false,
      productInfo: {},
    }
  },
  provide() {
    return {
      context: this
    }
  },
  watch: {
    currentPage() {
      this.getProductList();
    },
    pageSize() {
      this.getProductList();
    }
  },
  mounted() {
    this.getProductList();
  },

  methods: {
    async getProductList() {
      const {
        id,
        productName,
        productType,
        status,
        businessUserId,
        cooperationMethod,
        sortField
      } = this.searchData;
      let params = {
        id,
        productName,
        productType,
        status,
        businessUserId,
        cooperationMethod,
        sortField,
        page: this.currentPage,
        pageSize: this.pageSize
      };
      const res = await getProductListAPI(params);
      this.list = res.list || [];
      this.total = res.total;
    },
    handleSortChange(column) {
      if (column) {
        let sortWay = column.order == 'ascending' ? '+' : '-';
        this.searchData.sortField = column.prop + sortWay;
        this.getProductList();
      }
    },
    // 状态
    editStatus(row) {
      let { id, status } = row;
      let data = { id, status };
      let desc = status ? '上架' : '下架';
      this.$confirm(`此操作将${desc}该商品, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          row.status = status;
          editStatusAPI(data).then(() => {
            this.getProductList();
            this.$message.success('操作成功');
          })
        })
        .catch(() => {
          row.status = !status;
          this.$message({ type: 'info', message: '已取消操作' });
        })
    },
    // 删除
    handleDel(id) {
      this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteProductAPI(id).then(() => {
            this.$message({ type: 'success', message: '操作成功!' });
            this.getProductList();
          })
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' });
        })
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.$refs.productTable.handleSortClear();
      this.getProductList();
    },
    handleWeight(row) {
      this.productInfo = row;
      this.dialogWeight = true;
    },
    submitWeight() {
      let data = {
        id: this.productInfo.id,
        productWeight: this.productInfo.newProductWeight,
      };
      editWeightAPI(data).then(() => {
        this.$message.success('操作成功');
        this.getProductList();
        this.dialogWeight = false;
        this.productInfo = {};
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;

  .header-search {
    margin-top: 20px;
  }

  .header-tabs {
    margin-bottom: 20px;
  }

  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
